// src/constants/metricsDefinitions.js

// src/constants/metricsDefinitions.js
const metricDefinitions = {
  //
  // LIQUIDITY
  //
  currentRatio:
    "Q: Can the company cover its short-term obligations?<br /><br />Measures a company’s ability to pay short-term liabilities with short-term assets. A ratio above 1.0 typically indicates reasonable liquidity.<br /><br />Higher is generally better.",

  quickRatio:
    "Q: Can the company quickly pay its short-term debts without selling inventory?<br /><br />A stricter liquidity measure than the current ratio, excluding inventory. Shows the ability to meet short-term obligations using only liquid assets.<br /><br />Higher is better.",

  cashRatio:
    "Q: How much of its short-term debt can the company pay using only cash?<br /><br />Compares cash and cash equivalents to current liabilities. Indicates the ability to meet near-term obligations without relying on receivables or inventory.<br /><br />Higher is better, but extremely high values may indicate underused cash.",

  //
  // PROFITABILITY
  //
  grossProfitMargin:
    "Q: How efficiently does the company produce its goods or services?<br /><br />Shows how much of each dollar of revenue is left after direct production costs (cost of goods sold). High margins suggest good pricing power or strong cost control.<br /><br />Higher is better.",

  operatingProfitMargin:
    "Q: How profitable is the company from its core operations?<br /><br />Measures profit from core operations after operating expenses (but before interest and taxes). Useful for judging underlying business efficiency.<br /><br />Higher is better.",

  netProfitMargin:
    "Q: How much profit does the company keep from its revenue after all expenses?<br /><br />Shows the percentage of revenue that becomes net income after operating costs, interest, and taxes. A key measure of overall profitability.<br /><br />Higher is better.",

  ebitMargin:
    "Q: How profitable is the business before interest and taxes?<br /><br />EBIT margin compares earnings before interest and taxes to revenue. It isolates operating performance before capital structure and tax effects.<br /><br />Higher is better.",

  ebitdaMargin:
    "Q: How strong is the company’s cash-like operating profitability?<br /><br />EBITDA margin removes non-cash charges like depreciation and amortization. Often used to compare operational performance across capital-intensive businesses.<br /><br />Higher is better.",

  pretaxProfitMargin:
    "Q: How profitable is the company before taxes?<br /><br />Compares pre-tax income to revenue. Useful for understanding profitability before the impact of different tax regimes.<br /><br />Higher is better.",

  continuousOperationsProfitMargin:
    "Q: How profitable are the ongoing, continuing parts of the business?<br /><br />Measures profit from continuing operations as a percentage of revenue, excluding one-off or discontinued items.<br /><br />Higher is better.",

  bottomLineProfitMargin:
    "Q: What is the true bottom-line profitability of the company?<br /><br />Represents net profit after all expenses, interest, and taxes as a percentage of revenue. Effectively another lens on the company’s final profit margin.<br /><br />Higher is better.",

  //
  // EFFICIENCY / OPERATIONS
  //
  assetTurnover:
    "Q: How efficiently does the company use its assets to generate revenue?<br /><br />Compares revenue to total assets. A higher ratio means the company is generating more sales per unit of assets.<br /><br />Higher is better.",

  inventoryTurnover:
    "Q: How quickly does the company sell and replace its inventory?<br /><br />Shows how many times inventory is sold over a period. High turnover can indicate strong demand or efficient inventory management, while very high values may signal stock-out risk.<br /><br />Higher is generally better, within reason.",

  receivablesTurnover:
    "Q: How quickly does the company collect cash from customers?<br /><br />Measures how many times accounts receivable are collected in a period. Higher values indicate faster collections and better credit management.<br /><br />Higher is better.",

  payablesTurnover:
    "Q: How quickly does the company pay its suppliers?<br /><br />Shows how often accounts payable are paid during a period. Lower values can mean better use of supplier credit, but very low values may strain relationships.<br /><br />Moderate or lower is usually better, as long as suppliers are comfortable.",

  fixedAssetTurnover:
    "Q: How efficiently does the company use its fixed assets to generate revenue?<br /><br />Compares revenue to net fixed assets (e.g., property, plant, equipment). High values suggest efficient use of long-term assets.<br /><br />Higher is better.",

  //
  // RISK & LEVERAGE
  //
  debtToAssetsRatio:
    "Q: What portion of the company’s assets is financed by debt?<br /><br />Compares total debt to total assets. Higher values indicate more leverage and higher financial risk.<br /><br />Lower is generally better.",

  debtToEquityRatio:
    "Q: How much debt does the company use relative to shareholders’ equity?<br /><br />Shows the balance between debt and equity financing. Very high values can signal elevated financial risk and sensitivity to interest rates.<br /><br />Lower is usually better, though capital-intensive industries may run higher ratios.",

  debtToCapitalRatio:
    "Q: How much of the company’s capital structure is funded by debt?<br /><br />Compares total debt to the sum of debt and equity. Indicates overall leverage in the capital structure.<br /><br />Lower is generally better.",

  longTermDebtToCapitalRatio:
    "Q: How reliant is the company on long-term debt financing?<br /><br />Focuses on long-term debt as a share of total capital. High values can point to refinancing risk and long-duration interest exposure.<br /><br />Lower is better.",

  financialLeverageRatio:
    "Q: How much are the company’s assets magnified relative to equity?<br /><br />Often calculated as total assets divided by total equity. Higher leverage boosts returns in good times but increases risk in downturns.<br /><br />Lower to moderate is generally safer.",

  //
  // CASH FLOW
  //
  operatingCashFlowRatio:
    "Q: Can the company cover its current liabilities with operating cash flow?<br /><br />Compares operating cash flow to current liabilities. Indicates the ability to service short-term obligations from core business cash generation.<br /><br />Higher is better.",

  operatingCashFlowSalesRatio:
    "Q: How much operating cash flow is generated per dollar of sales?<br /><br />Shows the share of revenue that turns into operating cash flow, a cash-based profitability measure.<br /><br />Higher is better.",

  freeCashFlowOperatingCashFlowRatio:
    "Q: How much of operating cash flow remains after capital expenditures?<br /><br />Measures the proportion of operating cash flow that becomes free cash flow after investing in property, plant, and equipment.<br /><br />Higher is better.",

  operatingCashFlowPerShare:
    "Q: How much operating cash flow is generated for each share?<br /><br />Shows operating cash flow divided by the number of shares outstanding. Useful for comparing cash generation on a per-share basis across companies.<br /><br />Higher is better.",

  freeCashFlowPerShare:
    "Q: How much free cash flow is available per share?<br /><br />Represents free cash flow after capital expenditures on a per-share basis. Important for assessing the capacity to pay dividends, buy back stock, or reduce debt.<br /><br />Higher is better.",

  //
  // VALUATION
  //
  priceToEarningsRatio:
    "Q: How expensive is the stock relative to its earnings?<br /><br />Shows how much investors are paying for each dollar of earnings. High P/E ratios can reflect strong growth expectations, while low P/E can suggest value or potential issues.<br /><br />Lower is generally better, unless strong growth justifies a premium.",

  priceToSalesRatio:
    "Q: How is the stock valued relative to its revenue?<br /><br />Compares market value to revenue. Useful when earnings are volatile or negative. High values can indicate rich valuations.<br /><br />Lower is generally better.",

  priceToFreeCashFlowRatio:
    "Q: How expensive is the stock based on its free cash flow?<br /><br />Compares the company’s market value to its free cash flow. A lower ratio can indicate a more attractively valued cash generator.<br /><br />Lower is better.",

  priceToOperatingCashFlowRatio:
    "Q: How expensive is the stock relative to operating cash flow?<br /><br />Compares market value to operating cash flow, providing a cash-based valuation view.<br /><br />Lower is better.",

  priceToBookRatio:
    "Q: How is the stock priced relative to its net asset value?<br /><br />Compares market price to book value per share. Very high values can indicate strong market confidence or overvaluation; very low values can signal distress or undervaluation.<br /><br />Lower is generally better, but sector norms matter.",

  enterpriseValueMultiple:
    "Q: How expensive is the company relative to its EBITDA (cash-like earnings)?<br /><br />Often referred to as EV/EBITDA. Compares enterprise value (equity + debt – cash) to EBITDA, and is widely used to compare valuations across companies and industries.<br /><br />Lower is usually better.",

  //
  // PER-SHARE METRICS
  //
  revenuePerShare:
    "Q: How much revenue does the company generate per share?<br /><br />Shows total revenue divided by shares outstanding. Useful for comparing business scale on a per-share basis.<br /><br />Higher is better.",

  netIncomePerShare:
    "Q: How much net income is attributable to each share?<br /><br />Essentially earnings per share (EPS) based on net income. Core profitability metric for equity holders.<br /><br />Higher is better.",

  cashPerShare:
    "Q: How much cash backs each share of stock?<br /><br />Indicates cash and cash equivalents per share. High values can provide a margin of safety and financial flexibility.<br /><br />Higher is better.",

  bookValuePerShare:
    "Q: What is the accounting value of each share based on the balance sheet?<br /><br />Represents shareholders’ equity divided by the number of shares. Often used together with the price-to-book ratio.<br /><br />Higher book value per share, for a given price, is better.",

  tangibleBookValuePerShare:
    "Q: What is each share worth excluding intangible assets like goodwill?<br /><br />Similar to book value per share but removes intangibles. Useful for conservative asset-based valuation.<br /><br />Higher is better.",

  shareholdersEquityPerShare:
    "Q: How much shareholders’ equity supports each share?<br /><br />Shows total shareholders’ equity divided by shares outstanding. Another way to view the company’s capital base on a per-share basis.<br /><br />Higher is better."
};

export default metricDefinitions;


// const metricDefinitions = {
//   currentRatio:
//     "Q: Can the company cover its short-term obligations?<br /><br />Measures a company’s ability to pay short-term liabilities with short-term assets. A ratio above 1.0 typically indicates good liquidity.<br /><br />Higher is generally better.",

//   quickRatio:
//     "Q: Can the company quickly pay its short-term debts without selling inventory?<br /><br />A more stringent liquidity measure than the current ratio, excluding inventory. Shows the ability to meet short-term obligations using only liquid assets.<br /><br />Higher is better.",

//   grossProfitMargin:
//     "Q: How efficiently does the company produce its goods or services?<br /><br />Indicates how well a company controls its production costs relative to revenue. Higher margins suggest better cost control or pricing power.<br /><br />Higher is better.",

//   operatingProfitMargin:
//     "Q: How profitable is the company from its core operations?<br /><br />Reflects core operating profitability before interest and taxes. Useful for assessing efficiency of core operations.<br /><br />Higher is better.",

//   netProfitMargin:
//     "Q: How much actual profit does the company keep from its revenue?<br /><br />Shows the percentage of revenue that turns into profit after all expenses. A key measure of overall profitability.<br /><br />Higher is better.",

//   returnOnAssets:
//     "Q: How effectively is the company using its assets to generate profit?<br /><br />Indicates how efficiently a company uses its assets to generate net income. Higher values imply better asset utilization.<br /><br />Higher is better.",

//   returnOnEquity:
//     "Q: How well is the company rewarding its shareholders?<br /><br />Measures how effectively a company generates profit from shareholders’ equity. A key profitability metric for investors.<br /><br />Higher is better.",

//   debtEquityRatio:
//     "Q: How much financial risk is the company taking on through debt?<br /><br />Shows the proportion of debt to shareholder equity. High values may indicate higher financial risk due to leverage.<br /><br />Lower is better.",

//   freeCashFlowPerShare:
//     "Q: How much free cash flow is available per share?<br /><br />Represents the company’s free cash flow divided by its number of outstanding shares. Useful for comparing cash generation on a per-share basis.<br /><br />Higher is better.",

//   freeCashFlowOperatingCashFlowRatio:
//     "Q: How much of the operating cash flow turns into free cash flow?<br /><br />Shows the percentage of operating cash flow that remains after capital expenditures. Higher ratios indicate better cash efficiency.<br /><br />Higher is better.",

//   priceToFreeCashFlowsRatio:
//     "Q: How expensive is the stock based on its free cash flow?<br /><br />Valuation metric comparing market capitalization to free cash flow. Lower values may indicate undervaluation.<br /><br />Lower is better.",

//   priceEarningsRatio:
//     "Q: How expensive is the stock relative to its earnings?<br /><br />Valuation metric showing how much investors are willing to pay per dollar of earnings. High values may signal growth expectations or overvaluation.<br /><br />Lower is generally better, unless growth is expected.",

//   priceToSalesRatio:
//     "Q: Is the stock overvalued or undervalued based on revenue?<br /><br />Valuation ratio comparing a company’s stock price to its revenues. Useful when earnings are negative or volatile.<br /><br />Lower is better."
// };

// export default metricDefinitions;

